import {
  FormControl,
  Grid,
  Switch,
  SwitchProps,
  Typography,
  styled,
} from '@mui/material';
import { Control, Controller } from 'react-hook-form';

import { GridSizeType, gridSizeMdLg6 } from '@/shared';

export type SwitchComponenteFormProps = {
  label: string;
  control: Control<any, any>;
  name: string;
  defaultValue: boolean;
  onChangeValue?: (e?: boolean) => void;
  disabled?: boolean;
  size?: GridSizeType;
};

const IOSSwitch = styled((props: SwitchProps) => (
  <Switch focusVisibleClassName=".Mui-focusVisible" disableRipple {...props} />
))(({ theme }) => ({
  width: 42,
  height: 26,
  padding: 0,
  '& .MuiSwitch-switchBase': {
    padding: 2,
    transition: theme.transitions.create(['transform'], {
      duration: 300,
      easing: theme.transitions.easing.easeInOut,
    }),
    '&.Mui-checked': {
      transform: 'translateX(16px)',
      color: '#fff',
      '& + .MuiSwitch-track': {
        backgroundColor: theme.palette.mode === 'dark' ? '#ccc' : '#6366F1',
        opacity: 1,
        border: 0,
      },
      '&.Mui-disabled + .MuiSwitch-track': {
        opacity: 0.5,
      },
    },
    '&.Mui-focusVisible .MuiSwitch-thumb': {
      color: '#6366F1',
      border: '6px solid #fff',
    },
    '&.Mui-disabled .MuiSwitch-thumb': {
      color:
        theme.palette.mode === 'light'
          ? theme.palette.grey[100]
          : theme.palette.grey[600],
    },
    '&.Mui-disabled + .MuiSwitch-track': {
      opacity: theme.palette.mode === 'light' ? 0.7 : 0.3,
    },
  },
  '& .MuiSwitch-thumb': {
    width: 22,
    height: 22,
    boxSizing: 'border-box',
    transition: theme.transitions.create(['background-color'], {
      duration: 300,
    }),
  },
  '& .MuiSwitch-track': {
    borderRadius: 13,
    backgroundColor: theme.palette.mode === 'light' ? '#ccc' : '#39393D',
    opacity: 1,
    transition: theme.transitions.create(['background-color', 'opacity'], {
      duration: 300,
      easing: theme.transitions.easing.easeInOut,
    }),
  },
}));

const containerStyle = {
  display: 'flex',
  width: '100%',
  justifyContent: 'space-between',
  alignItems: 'center',
} as const;

const typographyStyle = {
  width: '100%',
} as const;

const SwitchComponenteForm: React.FC<SwitchComponenteFormProps> = ({
  label,
  size = gridSizeMdLg6,
  control,
  defaultValue,
  name,
  onChangeValue,
  disabled,
}) => {
  return (
    <Grid item {...size}>
      <FormControl fullWidth>
        <Controller
          name={name}
          control={control}
          defaultValue={defaultValue}
          render={({ field }) => {
            const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
              const checked = e.target.checked;
              field.onChange(checked);
              onChangeValue?.(checked);
            };

            return (
              <div style={containerStyle}>
                <IOSSwitch
                  sx={{ m: 1 }}
                  checked={field.value || false}
                  onChange={handleChange}
                  disabled={disabled}
                />
                <Typography style={typographyStyle} variant="body2">
                  {label}
                </Typography>
              </div>
            );
          }}
        />
      </FormControl>
    </Grid>
  );
};

export default SwitchComponenteForm;